<app-full-screen-loader *ngIf="preventAbuse" />

<div class="sideMenuContainer open">
  <!--add class open to show menu-->
  <!-- <p-scrollPanel styleClass="scrollBarHeight" [style]="{ width: '100%' }"> -->
  <div *ngIf="selectedWorkspace" class="sideMenu">
    <div class="wrap">
      <div class="content">
        <div class="topMenu">
          <div
            pTooltip="Current Workspace: {{ selectedWorkspace.name }}"
            class="snap current-workspace"
            role="button"
          >
            <div class="workspace-avatar-badge">
              <p-avatar
                styleClass="workIcon"
                [style]="{
                  'background-color': '#' + selectedWorkspace.hex_color,
                  color: '#ffffff',
                }"
                [label]="selectedWorkspace.name.charAt(0).toUpperCase()"
                shape="circle"
              ></p-avatar>
              @if (selectedWorkspace.planInfo.subscriptionInfo?.subscription) {
                <span class="king-badge">pro</span>
              }
            </div>
          </div>
        </div>
        <p class="title">Menu</p>
        <div class="menuList">
          <ul class="list-unstyled">
            <li
              id="dashboard"
              pTooltip="Dashboard"
              tooltipPosition="right"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              title="Dashboard"
              class="dashboard"
            >
              <a [routerLink]="['/']">
                <i class="pi pi-home" style="color: #667085; font-size: 1.5rem"></i>
              </a>
            </li>
            <li
              id="createPost"
              pTooltip="Create Post"
              tooltipPosition="right"
              data-tour="create-post"
              [class.active]="router.url.startsWith('/create')"
              title="Create Post"
              class="edit"
              (click)="openCreatePostModal()"
              style="cursor: pointer"
            >
              <a (click)="$event.preventDefault()">
                <i class="pi pi-plus-circle" style="color: green; font-size: 1.5rem"></i>
              </a>
            </li>
            <li
              id="calendar-menu"
              pTooltip="Calendar"
              tooltipPosition="right"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: false }"
              title="Calendar"
              class="logo"
            >
              <a [routerLink]="['/planner/calendar']">
                <i class="pi pi-calendar" style="color: #667085; font-size: 1.5rem"></i>
              </a>
            </li>

            <li
              id="post-queue"
              pTooltip="Post Queue"
              tooltipPosition="right"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: false }"
              title="Post Queue"
              class="logo"
            >
              <a [routerLink]="['/post-schedule']">
                <i class="pi pi-calendar-clock" style="color: #667085; font-size: 1.5rem"></i>
              </a>
            </li>

            <li
              id="ai-writer-menu"
              pTooltip="AI Writer"
              tooltipPosition="right"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: false }"
              title="AI Writer"
              class="logo"
            >
              <a [routerLink]="['/ai/ai-writer']">
                <i class="pi pi-microchip-ai" style="color: #667085; font-size: 1.5rem"></i>
              </a>
            </li>

            <li
              id="analytics-menu"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: false }"
              pTooltip="Analytics"
              tooltipPosition="right"
              title="Analytics"
              class="edit"
            >
              <a [routerLink]="['/analytics']">
                <i class="pi pi-chart-pie" style="color: #667085; font-size: 1.5rem"></i>
              </a>
            </li>
          </ul>
        </div>

        <div class="bottomMenu">
          <ul class="list-unstyled">
            <li
              id="connections-menu"
              pTooltip="Manage connected accounts"
              tooltipPosition="right"
              title="Connections"
              class="logo"
              [class.active]="isConnectionsActive()"
            >
              <a
                [routerLink]="['/workspace/settings']"
                [queryParams]="{ selectedTab: 'connected-accounts' }"
              >
                <i class="pi pi-link" style="color: #667085; font-size: 1.5rem"></i>
              </a>
            </li>

            <li
              id="workspace-settings-menu"
              pTooltip="Workspace Settings"
              tooltipPosition="right"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: false }"
              title="Workspace Settings"
              class="logo"
            >
              <a [routerLink]="['/workspace/settings']">
                <i class="pi pi-building" style="color: #667085; font-size: 1.5rem"></i>
              </a>
            </li>

            @if (showUpgradeNav()) {
              <li
                id="upgrade-menu"
                class="logo upgrade-menu-item"
                pTooltip="Upgrade plan"
                tooltipPosition="right"
                title="Upgrade plan"
              >
                <a
                  class="upgrade-menu-link"
                  [routerLink]="['/plans']"
                  [queryParams]="{ id: selectedWorkspace?.uuid }"
                >
                  <img
                    src="/assets/images/menu/upgrade-nav.svg"
                    alt="Upgrade plan"
                    width="24"
                    height="24"
                  />
                </a>
              </li>
            }

            <li
              id="help-menu"
              pTooltip="Help & Support"
              tooltipPosition="right"
              title="Help & Support"
              class="logo"
            >
              <a href="https://support.confe.io" target="_blank">
                <i class="pi pi-question-circle" style="color: #667085; font-size: 1.5rem"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- </p-scrollPanel> -->
</div>

<!-- <p-overlayPanel #snap styleClass="subMenuPop"> -->
<p-menu styleClass="sideMenuOpt" appendTo="body" [model]="scheduleItems" #snap [popup]="true">
  <ng-template pTemplate="item" let-item>
    <a class="p-ripple p-element p-menuitem-link">
      <img class="mr-2" src="{{ item.icon }}" alt="" />
      <span> {{ item.label }}</span>
    </a>
  </ng-template>
</p-menu>
<!-- </p-overlayPanel> -->

<!-- <p-overlayPanel #createPost styleClass="subMenuPop"> -->
<p-menu
  styleClass="sideMenuOpt"
  appendTo="body"
  [model]="createPostItems"
  #createPost
  [popup]="true"
>
  <ng-template pTemplate="item" let-item>
    <a class="p-ripple p-element p-menuitem-link">
      <img class="mr-2" src="{{ item.icon }}" alt="" />
      <span [innerHTML]="item.label"></span>
    </a>
  </ng-template>
</p-menu>
<!-- </p-overlayPanel> -->

<!-- <p-overlayPanel #aimenu styleClass="subMenuPop"> -->
<p-menu styleClass="sideMenuOpt" appendTo="body" [model]="aiSubmenu" #aimenu [popup]="true">
  <ng-template pTemplate="item" let-item>
    <a class="p-ripple p-element p-menuitem-link">
      <img class="mr-2" src="{{ item.icon }}" alt="" />
      <span [innerHTML]="item.label"></span>
    </a>
  </ng-template>
</p-menu>
<!-- </p-overlayPanel> -->

<!-- <p-overlayPanel #submenu styleClass="subMenuBottomPop"> -->
<p-menu
  styleClass="sideMenuOpt subMenuBottomPop"
  appendTo="body"
  [model]="menuItems"
  #submenu
  [popup]="true"
></p-menu>
<!-- </p-overlayPanel> -->

<!-- <p-overlayPanel #workspacemenu styleClass="subMenuPop"> -->
<p-menu
  styleClass="sideMenuOpt"
  appendTo="body"
  [model]="workspaceMenu"
  #workspacemenu
  [popup]="true"
>
  <ng-template pTemplate="item" let-item>
    <a class="p-ripple p-element p-menuitem-link">
      <img *ngIf="!item.isWorkspace" class="mr-2" src="{{ item.icon }}" alt="" />
      <p-avatar
        *ngIf="item.isWorkspace"
        styleClass="workIcon mr-2"
        [style]="{
          'background-color': '#' + item.icon,
          color: '#ffffff',
        }"
        [label]="item.label.charAt(0).toUpperCase()"
        shape="circle"
      ></p-avatar>
      <div>
        <span [innerHTML]="item.label"></span>
        <div *ngIf="item.isInTrial">
          <span
            class="trials"
            *ngIf="!item.has_expired_trial && !item.isLifetimeFreeTrial"
            style="color: orange"
            >(In Trial)</span
          >
          <span class="trials" *ngIf="item.has_expired_trial" style="color: red"
            >(Trial expired)</span
          >
        </div>
      </div>
    </a>
  </ng-template>
</p-menu>
